import * as React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { currencyFormatter } from "@kalabo/golfsavers-common";

interface IProps {
  comparison?: boolean;
  base_currency: string;
  hide_decimal?: boolean;
  currency: string;
  value: number;
  simplify?: boolean;
  show_astrix?: boolean;
}

const XE = ({
  comparison = false,
  base_currency,
  currency,
  value = 0,
  hide_decimal = false,
  simplify = false,
  show_astrix = false,
}: IProps) => {
  const data = useStaticQuery(graphql`
    query {
      allGolfsaversExchangeRates {
        edges {
          node {
            currency
            base_currency
            rate
          }
        }
      }
    }
  `);

  const calculate_rate = () => {
    const rate = data.allGolfsaversExchangeRates.edges?.find(
      (edge: any) =>
        edge.node.currency.trim().toLowerCase() ===
          currency.trim().toLowerCase() &&
        edge.node.base_currency?.trim()?.toLowerCase() ===
          base_currency?.trim()?.toLowerCase()
    );

    if (rate && rate.node.rate !== 1) {
      let v = rate.node.rate * value;

      if (hide_decimal) v = Math.trunc(v);

      let val = currencyFormatter(currency, v, simplify);
      let base = currencyFormatter(base_currency, value, simplify);

      if (comparison) return `${base} (~${val})`;

      return (
        <>
          {`${val}`}
          {show_astrix && "*"}
        </>
      );
    }

    return currencyFormatter(currency, value, simplify);
  };

  return <>{calculate_rate()}</>;
};

export default XE;
